import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-sky-900 ${className}`} data-id="element-311">
      <div className="container mx-auto px-4" data-id="element-312">
        {title && <h2 className="font-bold text-center mb-12 text-white text-[16px] md:text-2xl" data-id="element-313">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-314">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-sky-950/70 p-6 rounded-2xl shadow-lg border border-sky-800 flex flex-col h-full" data-id="element-315">
              <div className="flex items-center gap-1 mb-4" data-id="element-316">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-317" />)}
              </div>

              <p className="text-sky-50 italic mb-6 flex-grow" data-id="element-318">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-sky-800/60" data-id="element-319">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-320">
                  {t.initials}
                </div>
                <div data-id="element-321">
                  <p className="font-bold text-white text-sm" data-id="element-322">{t.name}</p>
                  <p className="text-xs text-sky-200" data-id="element-323">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-sky-300 mt-0.5" data-id="element-324">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials = [{
  initials: 'VM',
  name: 'Valentina M.',
  location: 'Mamá · Córdoba',
  text: 'Nunca pensé que iba a saber exactamente qué hacer con mi bebé de 3 meses. Leí el Tomo 1 y esa misma tarde ya tenía actividades para hacer con lo que tenía en casa. La diferencia fue inmediata.',
  color: 'bg-sky-600'
}, {
  initials: 'RP',
  name: 'Romina P.',
  location: 'Mamá · Rosario',
  text: 'Mi hijo de 2 años no hablaba casi nada y yo no sabía si era normal o no. El Tomo 2 me explicó todo sin tecnicismos y me dio las actividades exactas para estimular su lenguaje. En un mes explotó con palabras nuevas.',
  color: 'bg-pink-500'
}, {
  initials: 'GM',
  name: 'Gabriela M.',
  location: 'Maestra de Nivel Inicial · Buenos Aires',
  text: 'Soy docente de sala de 4 años y llevaba años sin un recurso así en español argentino. El Tomo 4 me dio todo lo que necesitaba para mis alumnos en un solo lugar. Se lo recomendé a toda la sala de maestras.',
  color: 'bg-purple-500'
}];
export const moreTestimonials = [{
  initials: 'MR',
  name: 'Mariana R.',
  location: '🏙️ Mendoza',
  pack: 'Megapack Estimulación Temprana Listo',
  text: 'Soy mamá primeriza y el miedo que tenía de no hacer las cosas bien era paralizante. El Tomo 1 me dio la tranquilidad de saber exactamente qué esperar cada mes. Dejé de googlear a las 3 de la mañana.',
  color: 'bg-emerald-500'
}, {
  initials: 'JF',
  name: 'Jimena F.',
  location: '🏙️ Buenos Aires',
  pack: 'Megapack Estimulación Temprana Listo',
  text: 'Mi hijo de 2 años y medio tenía berrinches brutales y yo no sabía si era normal o si tenía que consultar. El Tomo 3 me explicó qué estaba pasando en su cerebro y me dio las herramientas exactas. Cambiamos el enfoque y en tres semanas la cosa mejoró mucho.',
  color: 'bg-sky-700'
}, {
  initials: 'AG',
  name: 'Andrea G.',
  location: '🏙️ La Plata',
  pack: 'Megapack Estimulación Temprana Listo',
  text: 'Soy maestra de sala de 4 años y llevaba años sin un recurso así en español y con contexto argentino. El Tomo 4 me cambió la planificación completa. Se lo recomendé a todas mis colegas.',
  color: 'bg-amber-500'
}, {
  initials: 'DP',
  name: 'Daniela P.',
  location: '🏙️ Neuquén',
  pack: 'Megapack + Sistema Maestro',
  text: 'El Sistema Maestro me cambió la dinámica familiar. Antes mi suegra hacía lo que quería con mi hijo. Ahora tenemos el acuerdo escrito, todos saben qué hacer y el nene está mucho más tranquilo.',
  color: 'bg-slate-700'
}, {
  initials: 'KL',
  name: 'Karina L.',
  location: '🏙️ Rosario',
  pack: 'Megapack + Sistema Maestro',
  text: 'Tengo mellizos de 4 años y la organización me consumía. El sistema de rutinas y los checklists del Megapack me salvaron la vida. Lo que me llevaba una hora de pensar ahora está resuelto en 5 minutos.',
  color: 'bg-rose-500'
}];